import { BoxProps, ColorOptions, TextInputNewProps, allThemes } from '@jfs/ui-new'

export const styles = {
  container: {
    h: '100%',
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
  } as BoxProps,
  innerContainer: {
    f: 1,
    justify: 'center',
    align: 'flex-start',
    flexDirection: 'row',
    marginTop: 98,
  } as BoxProps,
  searchContainer: {
    borderWidth: 1,
    p: 48,
    borderRadius: 4,
    borderColor: '#0070B61F' as ColorOptions,
    bg: '#0070B60A' as ColorOptions,
  } as BoxProps,
  textInputContainer: (error: boolean) =>
    ({
      flexDirection: 'row',
      borderColor: error ? 'ERROR' : 'BLUE_SHADE_PRIMARY',
      borderRadius: 4,
      borderWidth: 1,
      bg: 'WHITE',
    } as BoxProps),
  loadingContainer: { f: 1, flexDirection: 'row', justify: 'center', align: 'center', ph: 4 } as BoxProps,
  iconContainer: (isValid: boolean) =>
    ({
      bg: 'BLUE_SHADE_PRIMARY',
      h: 48,
      w: 48,
      underlayColor: 'TRANSPARENT',
      borderTopLeftRadius: 2,
      borderBottomLeftRadius: 2,
      borderTopRightRadius: 2,
      borderBottomRightRadius: 2,
      justify: 'center',
      disabled: !isValid,
      align: 'center',
    } as BoxProps),
  header: {
    flexDirection: 'row',
    p: 16,
    // justify: 'space-between',
    align: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#0000001F' as ColorOptions,
    h: 70,
  } as BoxProps,
  footer: {
    p: 16,
    direction: 'row',
    // justify: 'flex-end',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#0000001F' as ColorOptions,
    minHeight: 100,
    width: '100%',
  } as BoxProps,
  footerNonEntity: {
    p: 16,
    direction: 'row',
    justify: 'space-between',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#0000001F' as ColorOptions,
    minHeight: 120,
  } as BoxProps,
  textinputStyle: (isEditMode: boolean) =>
    ({
      type: 'body12',
      borderColor: isEditMode ? ('#d1d3e2' as ColorOptions) : 'WHITE',
      labelPaddingBottom: 10,
      borderRadius: isEditMode ? 4 : 0,
      labelFontFamily: 'jiotype-bold',
      fontFamily: 'jiotype-medium',
      labelColor: '#757575' as ColorOptions,
      labelFontSize: 12,
      fontSize: 12,
      selectionColor: isEditMode ? 'BLUE' : 'TRANSPARENT',
      paddingVertical: 9,
      padddingHorizontal: 16,
      color: 'BLACK_21' as ColorOptions,
      onFocusBorderWidth: isEditMode ? 1 : 0,
    } as unknown as TextInputNewProps),
  buttonBgView: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#214796' as ColorOptions,
    underlayColor: 'PRIMARY_STORNG' as ColorOptions,
    height: 45,
    marginTop: 8,
    borderRadius: 4,
  } as BoxProps,
  formContainer: {
    ph: 16,
    pv: 16,
    backgroundColor: allThemes.light.colors.WHITE,
    borderRadius: 8,
    alignSelf: 'center',
    mt: 16,
    minWidth: 300,
    maxWidth: 480,
  } as BoxProps,
}
